<app-nav></app-nav>

<div class="container">
  <div id="accordion" class="home-notifications">
    <div class="card">
      <a class="card-link" data-toggle="collapse" href="#collapseOne">
        <div class="card-header">
          Unread Notification
        </div>
      </a>
      <div id="collapseOne" class="collapse show" data-parent="#accordion" *ngFor="let detail of notifications">
        <div class="card-body" *ngIf="!detail.readByUser" [ngStyle]="{ 'background-image': 'url(' + detail.fileUrl + ')'}">
          <div>
          <div class="col-12">
            <div class="row">
              <div class="col-8">
                <label class="title">
                  {{detail.title}}
                </label>
              </div>
              <div class="col-4">
                <p class="date">
                  {{detail.created | date: 'dd-MMM-yyyy'}}
                </p>
              </div>
            </div>
          </div>
          <div class="col-12 mb30">
            <div class="row">
              <div class="col">
                <p class="desc">{{detail.message}}</p>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="row notifications-actions">
              <a class="btn btn-delete" data-toggle="modal" data-target="#deleteNotificationModal" (click)="openDeleteModal(detail)">Delete</a>
              <a class="btn btn-view" routerLink="/viewNotification/{{detail._id}}">View</a>
            </div>
          </div>
          </div>
        </div>
      </div>
      <div class="card">
        <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwo">
          <div class="card-header">
            Read Notification
          </div>
        </a>
        <div id="collapseTwo" class="collapse" data-parent="#accordion"  *ngFor="let detail of notifications">
          <div class="card-body"  *ngIf="detail.readByUser" [ngStyle]="{ 'background-image': 'url(' + detail.fileUrl + ')'}">
            <div class="col-12">
              <div class="row">
                <div class="col-8">
                  <label class="title">
                    {{detail.title}}
                  </label>
                </div>
                <div class="col-4">
                  <p class="date">
                    {{detail.created | date: 'dd-MMM-yyyy'}}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12 mb30">
              <div class="row">
                <div class="col">
                  <p class="desc">{{detail.message}}</p>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row notifications-actions">
                <a class="btn btn-delete" data-toggle="modal" data-target="#deleteNotificationModal" (click)="openDeleteModal(detail)">Delete</a>
                <a class="btn btn-view" routerLink="/viewNotification/{{detail._id}}">View</a>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="modal fade" id="deleteNotificationModal">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-body">
              <p>Are you sure you want to delete this Notification?</p>
              <button type="button" class="close noButton" data-dismiss="modal">No</button>
              <button type="button" class="close" data-dismiss="modal" (click)="deleteNotification()">Yes</button>
            </div>
          </div>
        </div>
      </div>
    </div>